import Axios from "../../src/helpers/axios";

export const getAllCurrencies = () => {
  return Axios.get("/api/ecommerce/v1/currencies");
};